import { Badge } from "@bcc/components/ui/badge";
import { CellContext } from "@tanstack/react-table";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { setPendingBadgeTestId, setRequestsCellTestId } from "../products-table.utils";
import { VariantWithProductData } from "../types";
import { PendingRequestsModal } from "./PendingRequestsModal";

export const RequestsCellMarkup = (props: CellContext<VariantWithProductData, unknown>) => {
  const { t } = useTranslation();
  const row = props.row.original;
  const requests = row.approvalRequestsForRow ?? [];
  const pendingCount = row.pendingActionCount ?? 0;
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div data-testid={setRequestsCellTestId(props.row.index)} className="flex items-center gap-1">
      {pendingCount > 0 && (
        <>
          <Badge
            asChild
            variant="secondary"
            testId={setPendingBadgeTestId(props.row.index)}
            className="cursor-pointer bg-blue-500/10 text-blue-700 dark:text-blue-400 hover:bg-blue-500/20 transition-colors"
          >
            <button type="button" onClick={() => setIsModalOpen(true)}>
              {pendingCount} {t("views.productsTable.requests.pending")}
              <ChevronRight className="ml-1 h-3 w-3" />
            </button>
          </Badge>
          <PendingRequestsModal open={isModalOpen} onOpenChange={setIsModalOpen} requests={requests} />
        </>
      )}
    </div>
  );
};
